export const USAGE_VIEW_TYPES = {
    HOURLY: "hourly",
    DAILY: "daily"
};
